import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, loginUser } from './redux/auth/authSlice';
import { useThemeColors } from './hooks/useThemeColors';
import { FaTimes } from 'react-icons/fa';

const Login = ({ darkMode, onClose, isPopup, onSwitchToRegister }) => {
  const { themeBg, textColor, cardBg, borderColor, isDark, subTextColor } =
    useThemeColors(darkMode);
  const user = useSelector(getCurrentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (!userName || !password) return;

    dispatch(
      loginUser({
        userNameOrEmailAddress: userName,
        password,
        rememberClient: true,
      })
    );
  };

  useEffect(() => {
    if (user && user.id) {
      if (isPopup) onClose();
      else navigate('/');
    }
  }, [user, navigate, isPopup, onClose]);

  const inputStyle = {
    backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : '#fff',
    color: textColor,
    border: `1px solid ${borderColor}`,
    borderRadius: '12px',
    padding: '12px 15px',
    fontSize: '16px',
  };

  return (
    <div
      className="login-master-wrapper d-flex justify-content-center align-items-end align-items-md-center"
      style={{
        zIndex: 1200,
        backgroundColor: isPopup ? 'rgba(0,0,0,0.5)' : themeBg,
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="login-card-container rounded shadow-lg position-relative border-0"
        style={{
          width: '100%',
          maxWidth: '450px',
          backgroundColor: cardBg,
          color: textColor,
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()} // Card ke andar click hone pe popup band na ho
      >
        {/* Close Button */}
        {isPopup && (
          <button
            onClick={onClose}
            className="btn p-2 border-0 position-absolute top-0 end-0 mt-3 me-3"
            style={{ color: subTextColor, zIndex: 10 }}
          >
            <FaTimes size={20} />
          </button>
        )}

        <div className="p-3 py-md-5">
          <div className="text-center mb-4">
            <h2
              className="fw-bold mb-1"
              style={{ letterSpacing: '-1.5px', fontSize: '2rem' }}
            >
              Login
            </h2>
            <p className="small px-3" style={{ color: subTextColor }}>
              Welcome back! Enter your details to access your account.
            </p>
          </div>

          <form onSubmit={handleLogin} className="w-100 mx-auto">
            <div className="mb-3">
              <label
                className="form-label fw-bold small text-uppercase mb-2"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Email / Username
              </label>
              <input
                type="text"
                placeholder="Your email or username"
                className="form-control shadow-none"
                style={inputStyle}
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <label
                className="form-label fw-bold small text-uppercase mb-2"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Password
              </label>
              <input
                type="password"
                placeholder="••••••••"
                className="form-control shadow-none"
                style={inputStyle}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="d-grid gap-3">
              <button
                type="submit"
                className="btn btn-danger py-3 fw-bold shadow-sm rounded-3 text-uppercase"
                style={{ fontSize: '14px', letterSpacing: '1px' }}
              >
                Log In
              </button>

              <div className="d-flex align-items-center my-1">
                <hr
                  className="flex-grow-1 opacity-25"
                  style={{ borderColor: borderColor }}
                />
                <span className="mx-3 small opacity-50 fw-bold">OR</span>
                <hr
                  className="flex-grow-1 opacity-25"
                  style={{ borderColor: borderColor }}
                />
              </div>

              <button
                type="button"
                className={`btn ${
                  isDark ? 'btn-outline-light' : 'btn-outline-dark'
                } py-3 fw-bold rounded-3 text-uppercase`}
                style={{ fontSize: '12px', borderColor: borderColor }}
                onClick={() =>
                  isPopup ? onSwitchToRegister() : navigate('/registration')
                }
              >
                Create New Account
              </button>
            </div>
          </form>

          <div
            className="text-center mt-5 opacity-50"
            style={{ fontSize: '11px' }}
          >
            By continuing, you agree to our <br />
            <b>Terms of Service & Privacy Policy</b>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;
